<template>
    <div class="unsettled-content">
        <div class="unsettled__row" v-for="(item, index) in unsettledData" :key="index">
            <template v-if="$store.state.isScreenMobile">
                <div class="m-col">
                    <div class="m-row">
                        <div class="unsettled--infor">
                            <p class="game-name">{{ getTranslatedText(item.gameName) }}</p>
                            <p class="outcome-name">{{ getTranslatedText(item.marketName) }}</p>
                            <p class="draws-date">{{ item.drawDate }}</p>
                        </div>
                        <div class="list-number">
                            <template v-if="item.numbers?.length > 0">
                                <Number v-for="(n, i) in item.numbers" :key="i" :number="n.value" :bgColor="n.color"
                                    :customClass="'number__in-list'" />
                            </template>
                            <p v-else>{{ item.marketOptionName }}</p>
                        </div>
                    </div>
                    <div class="m-row">
                        <p class="stake">{{ getTranslatedText('stake') }}: {{ currencySymbol }} {{ formatPrice(+item.wager) }} <span v-if="item.betType == 'promo'"><strong>({{ getTranslatedText('Free bet') }})</strong></span></p>
                        <p class="odds">{{ getTranslatedText('odds') }}: {{ formatPrice(+item.odds) }}</p>
                        <p class="return-value">
                            {{ getTranslatedText('Potential winnings') }}
                            <span>
                                {{ currencySymbol }} {{ formatPrice(item.returnValue) }}
                            </span>
                        </p>
                        <p class="ref">{{ getTranslatedText('bet ref') }} {{ item.reference }}</p>
                    </div>
                </div>

            </template>
            <template v-else>
                <div class="unsettled__column-05 ">
                    <p class="game-name">{{ getTranslatedText(item.gameName) }}</p>
                </div>
                <div class="unsettled__column ">
                    <p class="outcome-name">{{ getTranslatedText(item.marketName) }}</p>
                </div>
                <div class="unsettled__column-2 ">
                    <p class="draws-date">{{ item.drawDate }}</p>
                </div>
                <div class="unsettled__column-3 ">
                    <div class="list-number">
                        <template v-if="item.numbers?.length > 0">
                            <Number v-for="(n, i) in item.numbers" :key="i" :number="n.value" :bgColor="n.color"
                                :customClass="'number__in-list'" />
                        </template>
                        <p v-else>{{ getTranslatedText(item.marketOptionName) }}</p>
                    </div>
                </div>
                <div class="unsettled__column-15 ">
                    <p class="stake">{{ getTranslatedText('stake') }}:  {{ currencySymbol }} {{ formatPrice(+item.wager) }}<br>
                        <span v-if="item.betType == 'promo'"><strong>({{ getTranslatedText('Free bet') }})</strong></span></p>
                </div>
                <div class="unsettled__column-15 ">
                    <p class="odds">{{ getTranslatedText('odds') }}: {{ formatPrice(+item.odds) }}</p>
                </div>

                <div class="unsettled__column-15 ">
                    <p class="return-value">
                        {{ getTranslatedText('Potential winings') }}
                        <span>
                            {{ currencySymbol }} {{ formatPrice(item.returnValue) }}
                        </span>
                    </p>
                </div>
                <div class="unsettled__column-15 ">
                    <p class="ref">{{ getTranslatedText('bet ref') }} {{ item.reference }}</p>
                </div>
            </template>
        </div>
    </div>
    <EmptyComponent :description="getTranslatedText('Please login to continue!')" v-if="!$store.state.isLogin" />
    <EmptyComponent :description="getTranslatedText('data is empty')" v-else-if="unsettledData?.length == 0" />
    <div class="paging" v-else>
        <PagingComponent :paginator="paginator" :itemsPerPage="5" />
    </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import Number from "@/components/common/number";
import PagingComponent from "@/components/common/paging";
import EmptyComponent from '@/components/common/empty';

export default {
    mixins: [languageMixins, utilsMixins],
    components: { Number, PagingComponent, EmptyComponent },
    props: {
        bets: {
            type: Array
        },
        currencySymbol: String,
        paginator: {}
    },
    data() {
        return {
            unsettledData: []
        }
    },
    created() {
        this.unsettledData = this.handleConvertData(this.bets)
    },
    watch: {
        bets: {
            handler(bets) {
                this.unsettledData = this.handleConvertData(bets);
            },
            deep: true,
        },
        "$store.state.gameMarket"() {
            this.unsettledData = this.handleConvertData(this.bets);
        },
    },
    methods: {
        handleConvertData(bets) {
            if (!bets) return [];
            const gameNumbers = this.$store.state.gameMarket || [];
            return bets.map((item) => {
                let numbers = gameNumbers.find(x => x.slug == item.game_slug)?.balls;
                let results = item.numbers
                const picked = results?.[0] || [];
                return {
                    id: item.id,
                    gameName: item.game_name,
                    pick: item.mo_pick,
                    marketName: item.market_name,
                    marketOptionName: item.mo_name,
                    drawDate: this.renderDateTimeText(item.draw_date),
                    numbers: numbers ? this.filterAndSortNumbers(numbers, picked) : [],
                    odds: item.odds,
                    wager: item.wager,
                    returnValue: item.wager * item.odds,
                    reference: item.reference,
                    betType: item.bet_type,
                }
            })
        }
    }

}
</script>

<style lang="scss">
@import "@/public/scss/components/my-bets/unsettled.scss";
</style>